/* global DetectUserAgent */
import { useSelector } from "react-redux";

import { useFilestackActions } from "store/FilestackSlice";

const useFilestack = () => {
  const isFbInAppBrowser = DetectUserAgent.isFBInAppBrowser();
  const { changeValue, resetValue } = useFilestackActions();

  const { handleView } = useSelector((state) => state.FilestackSlice);
  const setHandleViewStorage = (value) => {
    if (isFbInAppBrowser) {
      sessionStorage.setItem("filestackModal", value);
    }
    changeValue(value);
  };

  const resetValueToStorage = () => {
    if (isFbInAppBrowser) {
      sessionStorage.removeItem("filestackModal");
    }
    resetValue();
  };

  return {
    handleView,
    setHandleViewStorage,
    resetValueToStorage,
  };
};

export default useFilestack;
